/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Accedi per offrire',
                signup: 'Iscriviti per offrire',
                register_long: "Registrati per l'asta",
                pending: 'Registrazione in attesa',
                declined: 'Registrazione rifiutata',
                closed: 'Lotto chiuso',
                sent: 'La tua offerta è stata inviata',
                outbid: 'Sei stato superato, offri {amount}',
                bid: 'Offri {amount}',
                winning: 'Stai vincendo',
            },
            conversions: {
                lot_number: 'Lotto {lotNumber}',
            },
            description: {
                estimate_range: 'Stima {low} - {high}',
                images_label: '{currentImageNumber}/{totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: Offerta concorrente',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    "L'offerta concorrente è stata superata dall'offerta da assente di Offerente {paddleNumber}",
                last_bid_retracted: 'Ultima offerta di {amount} ritirata',
                liveauctioneers_bid_amount: '{amount}: Offerente LiveAuctioneers {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}: Offerta da assente di Offerente LiveAuctioneers {paddleNumber}',
                lot_number_passed: 'Lotto {lotNumber} passato',
                lot_number_reopened: 'Lotto {lotNumber} riaperto',
                lot_number_skipped: 'Lotto {lotNumber} saltato',
                lot_number_unsold: 'Lotto {lotNumber} non venduto',
                lot_opened_asking: 'Lotto {lotNumber} aperto - Richiesta {amount}',
                lot_sold_competing_bidder: "Lotto {lotNumber} venduto per {amount} all'offerente concorrente",
                lot_sold_liveauctioneers_bidder: 'Lotto {lotNumber} venduto per {amount} a Offerente {paddleNumber}',
                my_bid_amount: '{amount}: La mia offerta',
                my_bid_amount_absentee: '{amount}: La mia offerta da assente',
                my_bid_retracted: 'La tua offerta di {amount} è stata ritirata',
                registration_approved: 'La tua registrazione è stata approvata',
                reserve_not_met: 'Riserva non soddisfatta',
                you_been_outbid_by_liveauctioneers_absentee:
                    "Sei stato superato dall'offerta da assente di Offerente {paddleNumber}",
                you_ve_won_lot: 'Hai vinto il lotto {lotNumber}',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Avvertimento utile... Questo lotto sta per essere chiuso',
                going_once_going_twice: 'E UNO... E DUE...',
                third_and_final_warning: 'TERZO E ULTIMO AVVERTIMENTO...',
            },
            status: {
                remaining: '{remaining} lotti su {total} rimanenti',
            },
            thumbnail_scroller: {
                next: 'Lotti successivi',
            },
        },
    },
};
